import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="empty-state" data-testid="not-found">
      <p className="section-tag">Erreur 404</p>
      <h2>Page introuvable</h2>
      <p className="section-body">La page que vous recherchez n'existe pas ou a été déplacée.</p>
      <Link to="/" className="btn-primary">Retour à l'accueil</Link>
    </div>
  );
}
